import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useNavigate } from 'react-router';
import TopLogo from '../components/TopLogo';
export default function RPC() {
    const [details, setDetails] = useState({ uid: "",token: "",new_password: "",re_new_password: "", });
    const [err, setError] = useState("")
    var postdat={uid:'',token:''}
    useEffect(() => {
        var str = window.location.href;
        var res = str.split("/");
        postdat.token = res[(res.length) - 1];
        postdat.uid = res[(res.length) - 2];
        // document.getElementsByClassName('nav-menu')[0].style.display = 'none'
        // document.getElementsByClassName('navbar')[0].style.display = 'none'
    }, [])
    let navigate = useNavigate();
    const submitHandler = e => {
        var str = window.location.href;
        var res = str.split("/");
        postdat.token = res[(res.length) - 1];
        postdat.uid = res[(res.length) - 2];
        let div = document.getElementsByClassName('loadmain')[0];
        e.preventDefault();
        if (details.re_new_password ==details.new_password ) {
            div.style.display='flex';
            axios.post(`${process.env.REACT_APP_API_URL1}/auth/users/reset_password_confirm/`, {
                uid: postdat.uid,
                token: postdat.token,
                new_password:details.new_password,
                re_new_password:details.re_new_password,
            }).then(response => {
                div.style.display='none';
                setError({ color: 'green', data: 'Password is changed' })
                setTimeout(() => {
                    navigate('/SignIn')
                }, 1000);
            }).catch(err => {
                console.log(err)
                div.style.display='none';
                setError({ color: 'red', data: 'Error' })
            })
        }
        else { setError({ color: 'red', data: 'Password Mismatch' }) }

    }
    const styles = {
        backgroundColor: '#e5f4f1',
        borderBottom: ' 2px solid #0052b5',
        transition: '5ms'
    };
    return (
        <div className='signindiv'>
            {/* <TopLogo /> */}
            <img className='fixed' src={require('../IMAGES/background.png')}/>
            <form className='oth' onSubmit={submitHandler}>
                <div className='form-inner'>
                    <div>
                        <center><h2>Reset your password</h2></center>
                        <br /><br /><br />
                    </div>
                    <div style={{ color: err.color }} className='error'>{err.data}</div>
                    <div className='form-group'>
                        <label htmlfor='email'></label>
                        <input type="Password" name='Password' placeholder='Password..' onChange={e => setDetails({ ...details, new_password: e.target.value })} value={details.new_password} />
                    </div>
                    <div className='form-group'>
                        <label htmlfor='rePassword'></label>
                        <input type="text" name='rePassword' placeholder='Re-Enter Password..' onChange={e => setDetails({ ...details, re_new_password: e.target.value })} value={details.re_new_password} />
                    </div>
                    <div className='all'>
                        <button type='submit' className='signupbutton'>
                            Reset
                        </button>
                    </div>
                </div>
            </form>
        </div>
    )
}